export default __webpack_public_path__ + "static/SUSA_SvMiljobas-57a85acf1f534dd416184fcb789d0d81.svg";